import { useRef } from "react";
import { Helmet } from "react-helmet";
import "../Terms/styled.scss";
import "../../../home.scss";

const EndorsementHeader = () => {
  return (
    <div className="section terms_head" style={{}}>
      <div className="content_container">
        <div
          className="content terms_head"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div className="terms_head_left">
            <h1>Endorsement</h1>
            <h2>
              Learn more about our terms and policies regarding endorsement
              activities.
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

const EndorsementContent = () => {
  return (
    <div className="section terms" style={{}}>
      <div className="content_container" style={{}}>
        <div className="content terms">
          <div className="terms_body">
            <div className="terms_sec">
              <div className="title">
                <div className="text">Key terms and policies</div>
              </div>
              <div className="content">
                <p>
                  You are responsible for familiarizing yourself and complying
                  with the Federal Trade Commission’s Guides Governing
                  Endorsements, Testimonials (“FTC Endorsement Guides”),
                  available at{" "}
                  <a href="http://www.ftc.gov/opa/2009/10/endortest.shtm">
                    http://www.ftc.gov/opa/2009/10/endortest.shtm
                  </a>
                  . This means that when you communicate with others about
                  Brands (including when you post to social media, post a
                  product review on a retailer site, or send private text
                  messages to friends), you must disclose that you will receive
                  a reward, discount, or commission from the Brand. What you say
                  about the Brand and its products or services must be truthful
                  and reflect your honest opinions, findings, beliefs or
                  experiences. You also must have a reasonable basis for any
                  claims you make about the Brand or its products and services.
                  <br />
                  <br />
                  For more information on complying with the FTC Endorsement
                  Guidelines, please visit Disclosures 101 for Social Media
                  Influencers, at{" "}
                  <a href="https://www.ftc.gov/system/files/documents/plain-language/1001a-influencer-guide-508_1.pdf">
                    https://www.ftc.gov/system/files/documents/plain-language/1001a-influencer-guide-508_1.pdf
                  </a>{" "}
                  or The FTC’s Endorsement Guides: What People Are Asking at{" "}
                  <a href="https://www.ftc.gov/tips-advice/business-center/guidance/ftcs-endorsement-guides-what-people-are-asking">
                    https://www.ftc.gov/tips-advice/business-center/guidance/ftcs-endorsement-guides-what-people-are-asking
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Endorsement = () => {
  const ref = useRef(undefined) as any;
  const disable = false;
  if (disable) {
    return <></>;
  }
  return (
    <div className="site" ref={ref}>
      <Helmet>
        <title>Endorsement Policy</title>
        <meta
          name="description"
          content="Learn more about our terms and policies regarding endorsement activities."
        />
      </Helmet>
      <EndorsementHeader />
      <EndorsementContent />
    </div>
  );
};
export default Endorsement;
